import { render, staticRenderFns } from "./MessagesLimitInput.vue?vue&type=template&id=730cbdac&lang=pug&"
import script from "./MessagesLimitInput.vue?vue&type=script&lang=js&"
export * from "./MessagesLimitInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MessagesLimitInput.vue"
export default component.exports